"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Loading = void 0;
var _mui = require("@ori-ui/mui");
var _hooks = require("../../hooks");
var _Dialog = require("../Dialog");
var _jsxRuntime = require("react/jsx-runtime");
const Loading = ({
  show = false
}) => {
  const {
    translations
  } = (0, _hooks.useTranslations)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Dialog.Dialog, {
    hideCloseButton: true,
    open: show,
    header: translations.FindingProduct,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {
      color: "primary"
    })
  });
};
exports.Loading = Loading;